import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';
import dataService from 'services/dataService';
import { API_PATIENTS_READINGS_RESERVE } from 'services/dataService/resources';

import type { QueryKey } from '@tanstack/react-query';
import type { IReserveResponse } from 'infrastructure/interfaces/i-rpm-patient-activity';

interface Props {
  getActivityQueryKey: QueryKey;
}

const reservePatientFn = async (patientGuid: string) => {
  const { error, data } = await dataService.createOne<IReserveResponse>(
    API_PATIENTS_READINGS_RESERVE,
    {
      patientGuid,
    },
  );
  if (error) {
    showResult(error);
    return false;
  }

  return data;
};

export const useReservePatient = ({ getActivityQueryKey }: Props) => {
  const queryClient = useQueryClient();
  const { mutateAsync, ...other } = useMutation({
    mutationFn: reservePatientFn,
    onSuccess(data, patientGuid) {
      if (!data) return;
      const qKey = [getActivityQueryKey[0], { patientGuid }];
      queryClient.invalidateQueries(qKey);
    },
  });

  return {
    reservePatient: mutateAsync,
    ...other,
  };
};
